export default {
    GRAPH_SET_HOVER_MAP_ID: 'GRAPH_SET_HOVER_MAP_ID',
    GRAPH_SET_HOVER_GROUP_ID: 'GRAPH_SET_HOVER_GROUP_ID',
    GRAPH_SET_DRAG_OVER_GROUP_ID: 'GRAPH_SET_DRAG_OVER_GROUP_ID',
    GRAPH_SET_DRAGGING_DATA: 'GRAPH_SET_DRAGGING_DATA',
    GRAPH_SET_CONTEXT_MENU_DATA: 'GRAPH_SET_CONTEXT_MENU_DATA',
    GRAPH_SET_SEARCH: 'GRAPH_SET_SEARCH',
    GRAPH_SET_CLIPBOARD: 'GRAPH_SET_CLIPBOARD',

    NOTE_ADD: 'NOTE_ADD',
    NOTE_SET_ALL: 'NOTE_SET_ALL',
    NOTE_UPDATE: 'NOTE_UPDATE',
    NOTE_EDIT: 'NOTE_EDIT',
    NOTE_TOGGLE_VISIBILITY: 'NOTE_TOGGLE_VISIBILITY',
    NOTE_DELETE: 'NOTE_DELETE',
    NOTE_DELETE_MULTIPLE: 'NOTE_DELETE_MULTIPLE',
};
